import type { CSSProperties } from 'react';

import { Chip, type ChipProps } from '@mui/material';
import { cn } from 'cn';

import {
  STATUS_BG_OPACITY,
  statusPalette,
  type StatusTone,
} from '~/ui/styles/palette';

export type StatusBadgeProps = {
  className?: string;
  label: string;
  size?: ChipProps['size'];
  style?: CSSProperties;
  tone: StatusTone;
};

type StatusBadgeStyle = CSSProperties & {
  '--status-badge-bg'?: string;
  '--status-badge-fg'?: string;
};

function toMixedBackground(baseColor: string, opacity: number): string {
  return `color-mix(in oklab, ${baseColor} ${opacity * 100}%, transparent)`;
}

export function StatusBadge({
  className,
  label,
  size = 'small',
  style,
  tone,
}: StatusBadgeProps) {
  const palette = statusPalette[tone];
  const background = toMixedBackground(palette.bgBase, STATUS_BG_OPACITY);

  const cssVarStyle: StatusBadgeStyle = {
    '--status-badge-bg': background,
    '--status-badge-fg': palette.fg,
  };

  return (
    <Chip
      className={cn('px-1 select-none', className)}
      label={label}
      size={size}
      style={{ ...cssVarStyle, ...style }}
      sx={{
        '& .MuiChip-icon': {
          color: 'var(--status-badge-fg)',
        },
        backgroundColor: 'var(--status-badge-bg)',
        color: 'var(--status-badge-fg)',
      }}
      variant="filled"
    />
  );
}
